import { InjectionToken, type ValueProvider, inject } from '@angular/core';

export interface BrnButtonConfig {
  variant: 'default' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'link';
  size: 'default' | 'xs' | 'sm' | 'lg' | 'icon' | 'icon-xs' | 'icon-sm' | 'icon-lg';
}

const defaultConfig: BrnButtonConfig = { variant: 'default', size: 'default' };

const BrnButtonConfigToken = new InjectionToken<BrnButtonConfig>('BrnButtonConfig');

export function provideBrnButtonConfig(config: Partial<BrnButtonConfig>): ValueProvider {
  return { provide: BrnButtonConfigToken, useValue: { ...defaultConfig, ...config } };
}

export function injectBrnButtonConfig(): BrnButtonConfig {
  return inject(BrnButtonConfigToken, { optional: true }) ?? defaultConfig;
}
